import React from 'react'
import { x } from '@xstyled/styled-components'

export function BlogHero() {
  return (
    <x.section
      w={{ _: '100%', maxWidth: 'maxWidth' }}
      mx="auto"
      pt={{ _: '80px', md: '120px' }}
      pb={{ _: 8, md: 12 }}
      px={{ _: '30px', md: '60px' }}>
      <x.h1
        fontSize={{ _: '36px', md: '48px', xl: '60px' }}
        fontWeight="600"
        color="lime"
        lineHeight="1.1"
        mb={4}>
        Blog
      </x.h1>
      <x.p
        fontSize={{ _: '16px', md: '18px' }}
        color="vandog"
        lineHeight="1.6"
        maxW="600px">
        Latest news and insights about Web3 infrastructure, liquid staking, and
        onchain finance.
      </x.p>
    </x.section>
  )
}
